module.exports = __webpack_public_path__ + "images/goals/Screen shot 2010-09-02 at 11.05.02 AM.png";